import { ref, computed, watch, unref } from "vue";
import { useI18n } from "vue-i18n";
import { getAvailableActions } from "@/entities/transaction/api";
import { pickLabel } from "@/entities/workflow/model/adapters";

export function useAvailableActions(source) {
  const { locale } = useI18n();
  const loading = ref(false);
  const error = ref(null);
  const primary = ref(null);
  const linked = ref([]);

  const currentStatus = computed(() => primary.value?.current_status || null);

  const availableActions = computed(() => {
    const list = primary.value?.available_actions || [];
    return list.map((a) => ({
      code: a.code,
      label: pickLabel(a.label, locale.value),
      color: a.color,
      notary_action_codes: Array.isArray(a.notary_action_codes)
        ? a.notary_action_codes
        : [],
      raw: a,
    }));
  });

  async function refresh() {
    const s = unref(source) || {};
    const transactionId = s.transactionId;
    const applicationUuid = s.applicationUuid;
    if (transactionId == null && !applicationUuid) {
      primary.value = null;
      linked.value = [];
      return;
    }
    loading.value = true;
    error.value = null;
    const res = await getAvailableActions({ transactionId, applicationUuid });
    if (res.success) {
      primary.value = res.payload?.primary || null;
      linked.value = res.payload?.linked || [];
    } else {
      primary.value = null;
      linked.value = [];
      error.value = res.error;
    }
    loading.value = false;
  }

  watch(
    () => {
      const s = unref(source) || {};
      return `${s.transactionId ?? ""}|${s.applicationUuid ?? ""}`;
    },
    () => refresh(),
    { immediate: true }
  );

  return {
    loading,
    error,
    primary,
    linked,
    currentStatus,
    availableActions,
    refresh,
  };
}
